import * as React from 'react';
import { connect } from 'react-redux';

import Form from './Form';
import Circle from '../loading/Circle';

import { ReportSetting as ReportSettingActions } from '../../actions';

import IState from '../../interfaces/states';
import IReportSettings from '../../interfaces/IReportSettings';
import { Customer } from '../../store/models';

interface IOwnProps {
    className?: string,
}

interface IStateProps {
    isLoading: boolean,
    reportSettings: IReportSettings,
    customers: Customer[],
}

interface IDispatchProps {
    setCustomer: Function,
    setStartMs: Function,
    setEndMs: Function,
}

type IProps = IOwnProps & IStateProps & IDispatchProps;

function onChange(name: string, value: any, props: IProps) {
    if (name === 'customerId') {
        props.setCustomer(value);
    }

    if (name === 'dateRange') {
        const [start, end] = value;
        props.setStartMs(start);
        props.setEndMs(end);
    }
}

const FormContainer: React.StatelessComponent<IProps> = (props: IProps) => {
    if (props.isLoading) {
        return <div key="loading" className="navbar-text pull-right">
            <Circle size="sm" name='reportSettings' infinite />
        </div>;
    }

    return <Form
        key="settings"
        className={props.className}
        settings={props.reportSettings}
        customers={props.customers}
        onChange={(name, value) => onChange(name, value, props)} />;
}

FormContainer.propTypes = {
    isLoading: React.PropTypes.bool,
    reportSettings: React.PropTypes.object.isRequired,
    customers: React.PropTypes.array.isRequired,
    setCustomer: React.PropTypes.func.isRequired,
    setStartMs: React.PropTypes.func.isRequired,
    setEndMs: React.PropTypes.func.isRequired,
};

const mapStateToProps = (state: IState) => {
    const props = {
        reportSettings: state.reportSettings,
        customers: [],
        isLoading: false,
    }

    if (!state.customers.loading) {
        props.customers = state.customers.arr.map(cId => state.customers.byId[cId]);
    } else {
        props.isLoading = true;
    }

    return props;
};

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    {
        setCustomer: ReportSettingActions.setCustomer,
        setStartMs: ReportSettingActions.setStartMs,
        setEndMs: ReportSettingActions.setEndMs,
    }
)(FormContainer);



// WEBPACK FOOTER //
// ./src/components/reportSettings/FormContainer.tsx